import React from 'react';
import ReminderHour from './ReminderHour'
import ReminderDay from './ReminderDay'

import '../../App.css';
import '../../bootstrap.css';
const SCHEDULER_USERS_PATH = 'scheduler/users'; //'scheduler/users_test';

export default class RemindersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allReminders: {daily:{}, weekly:{}},
      hideDisabled: false,
      newHour: 0,
      newMinute: 0,
      newMessage: "",
      newDay: -1
    }
    
    this.showAllReminders = this.showAllReminders.bind(this);
    this.hideDisabled = this.hideDisabled.bind(this);
    this.showDisabled = this.showDisabled.bind(this);

    this.hourChange = this.hourChange.bind(this);
    this.minuteChange = this.minuteChange.bind(this);
    this.dayChange = this.dayChange.bind(this);
    this.messageChange = this.messageChange.bind(this);
    this.messageAdd = this.messageAdd.bind(this);
  }

  componentDidMount() {
    this.showAllReminders();
  }

  componentDidUpdate() {
    if (this.props.userId != this.prevUserId) {
      this.prevUserId = this.props.userId;
      this.showAllReminders();
    }
  }

  hideDisabled(e) {
    e.preventDefault();
    this.setState({hideDisabled: true});
  }

  showDisabled(e) {
    e.preventDefault();
    this.setState({hideDisabled: false});
  }

  hourChange(e) {
    this.setState({newHour: e.target.value});
  }

  minuteChange(e) {
    this.setState({newMinute: e.target.value});
  }

  dayChange(e) {
    this.setState({newDay: e.target.value});
  }

  messageChange(e) {
    this.setState({newMessage: e.target.value});
  }

  messageAdd(e) {
    e.preventDefault();
    let newMsgObj = { messages: [this.state.newMessage] };
    if (this.state.isCrewReport) {
      newMsgObj.type = 'crewreport';
    }

    if (this.state.newDay >= 0) {
      var path = `${SCHEDULER_USERS_PATH}/${this.props.userId}/weekly/${this.state.newDay}/${this.state.newHour}`;
      if (parseInt(this.state.newMinute) != 0) {
        path += "/" + this.state.newMinute;
      }
      var pathRef = this.props.firebase.database().ref(path);
      var newKey = pathRef.child('custom').push().key;
      var newRef = this.props.firebase.database().ref(path + '/custom/' + newKey);
      newRef.set(newMsgObj);
    } else {
      var path = `${SCHEDULER_USERS_PATH}/${this.props.userId}/${this.state.newHour}`;
      if (parseInt(this.state.newMinute) != 0) {
        path += "/" + this.state.newMinute;
      }
      var pathRef = this.props.firebase.database().ref(path);
      var newKey = pathRef.child('custom').push().key;
      var newRef = this.props.firebase.database().ref(path + '/custom/' + newKey)
      newMsgObj.ifNotMessagedWithinHours = 0;
      newRef.set(newMsgObj);
    }

    this.showAllReminders(e);
    this.setState({
      newHour: 0,
      newMinute: 0,
      newMessage: "",
      newDay: -1
    });
  }

  showAllReminders(e) {
    if (e) {e.preventDefault();}
    this.path = `${SCHEDULER_USERS_PATH}/${this.props.userId}`;
    this.props.firebase.database().ref(this.path).once("value").then(function(snapshot) {
      if (snapshot.exists()) {
        // TODO: Use parseInt() to filter our daily recurring vs weekly vs nonrecurring once we implement those.
        let allReminders = {daily: {}, weekly: {}};
        let reminders = snapshot.val();
        let reminderKeys = Object.keys(reminders);
        for (let i = 0; i < reminderKeys.length; i++) {
          let reminderKey = reminderKeys[i];
          if (!isNaN(reminderKey)) { // Daily recurring (reminderKey is the hour)
            allReminders.daily[reminderKey] = reminders[reminderKey];
          }
          else if (reminderKey === "weekly") { // Weekly recurring (reminderKey is day -> hour)
            let weeklyReminders = reminders[reminderKey];
            var weeklyReminderKeys = Object.keys(weeklyReminders);
            allReminders.weekly = {};
            for (let j = 0; j < weeklyReminderKeys.length; j++) {
              allReminders.weekly[weeklyReminderKeys[j]] = {
                reminders: weeklyReminders[weeklyReminderKeys[j]],
                dayName: this.getDayName(parseInt(weeklyReminderKeys[j]))
              }
            }
            
          }
        }

        this.setState({allReminders: allReminders});
      } else {
        // TODO
      }
    }.bind(this), function(error) {
        console.error(error);
    });
  }

  getDayName(day) {
    if (day === 0) {
      return "Sunday";
    } else if (day === 1) {
      return "Monday";
    } else if (day === 2) {
      return "Tuesday";
    } else if (day === 3) {
      return "Wednesday";
    } else if (day === 4) {
      return "Thursday";
    } else if (day === 5) {
      return "Friday";
    } else if (day === 6) {
      return "Saturday";
    }
  }

  checkboxChanged(event) {
    let target = event.target;
    let value = target.checked;
    let name = target.name;
    this.setState({
      [name]: value
    });
  }

  render() {
    // if (this.prevDate != this.props.date) {
    //   this.prevDate = this.props.date; // detect date has changed
    //   // TODO
    // }

    let collapseButton = this.state.hideDisabled ?
      (<input type="submit" onClick={this.showDisabled} value="Show all disabled reminders"/>) :
      ((<input type="submit" onClick={this.hideDisabled} value="Hide all disabled reminders"/>));

    let dayDropdown = (<select value={this.state.newDay} onChange={this.dayChange}>
      <option value="-1">Every day</option><option value="0">Sunday</option><option value="1">Monday</option>
      <option value="2">Tuesday</option><option value="3">Wednesday</option><option value="4">Thursday</option>
      <option value="5">Friday</option><option value="6">Saturday</option>
    </select>);

    let hourDropdown = (<select value={this.state.newHour} onChange={this.hourChange}>
      <option value="0">0</option><option value="1">1</option><option value="2">2</option><option value="3">3</option>
      <option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option>
      <option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option>
      <option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option>
      <option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option>
      <option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option>  
    </select>);

    let minuteDropdown = (<select value={this.state.newMinute} onChange={this.minuteChange}>
      <option value="0">00</option><option value="15">15</option><option value="30">30</option><option value="40">40</option><option value="50">50</option>
    </select>);

    let messageInput = this.state.isCrewReport ?
      (<span>(N/A for crew reports)</span>) : (<textarea type="text" value={this.state.newMessage} onChange={this.messageChange}/>);

    return (
      <div>
          <div>
            <b>Add new reminder</b>
            <div>
            Hour: {hourDropdown} Minute: {minuteDropdown} Message: {messageInput} Day: {dayDropdown} <input style={{marginLeft:'20px'}} type='checkbox' name='isCrewReport' checked={this.state.isCrewReport} onChange={this.checkboxChanged.bind(this)}></input>  This is a Crew Report
            <div style={{backgroundColor: 'yellow'}}><b>For food reminders, set message to "food". For progress reminders, set message to "progress".</b></div>
            <div><input type="submit" onClick={this.messageAdd} value="Add"/></div>
            </div>
          </div>
          <hr/>
          <input type="submit" onClick={this.showAllReminders} value="Refresh reminders"/>
          <hr/>
          <div>DAILY RECURRING reminders for <b>{this.props.userName}</b><br/>
            <ul>
            {Object.keys(this.state.allReminders.daily).map((key) =>
              <div key={key}>
                <li>
                  <b> Hour {key}</b>
                  <ReminderHour hour={key} hourItems={this.state.allReminders.daily[key]} userName={this.props.userName}
                    path={this.path + '/' + key} firebase={this.props.firebase} refresh={this.showAllReminders}
                    workoutsMap={this.props.workoutsMap} dailyHabitsMap={this.props.dailyHabitsMap}
                    weeklyHabitsMap={this.props.weeklyHabitsMap} hideDisabled={this.state.hideDisabled}/>
                </li>
              </div>
            )}
            </ul>
          </div>
        <hr/>

        <div>WEEKLY RECURRING reminders for <b>{this.props.userName}</b></div><br/>
          <ul>
            {Object.keys(this.state.allReminders.weekly).map((key) =>
              <div key={key}>
                <li>
                  <b>{this.state.allReminders.weekly[key].dayName}</b>
                  <ReminderDay day={key} dayItems={this.state.allReminders.weekly[key].reminders} userName={this.props.userName}
                    path={this.path + '/weekly/' + key} firebase={this.props.firebase} refresh={this.showAllReminders}
                    workoutsMap={this.props.workoutsMap} dailyHabitsMap={this.props.dailyHabitsMap}
                    weeklyHabitsMap={this.props.weeklyHabitsMap} hideDisabled={this.state.hideDisabled}/>
                </li>
              </div>
            )}
          </ul>
        <hr/>

        <div>NON-RECURRING reminders for <b>{this.props.userName}</b></div><br/>
        <p>(NOT IMPLEMENTED)</p>
        <hr/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/reminders/RemindersPage.js